import { render } from "./avatar_list.vue?vue&type=template&id=4cea5bcf"
import script from "./avatar_list.js?vue&type=script&lang=js"
export * from "./avatar_list.js?vue&type=script&lang=js"

import "./avatar_list.vue?vue&type=style&index=0&id=4cea5bcf&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__